const styles = theme => ({
  centerWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '16px',
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  emptyStateContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: 12,
    backgroundColor: '#F4F6F8',
    borderRadius: 8,
    height: '140px',
    width: '100%',
    maxWidth: '800px',
  },
  emptyStateTitle: {
    fontSize: 14,
    fontWeight: 500,
    color: '#002E47',
  },
  infoContainer: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
  infoIcon: {
    color: '#5DADFF',
    fontSize: 16,
  },
  infoText: {
    fontSize: 14,
    color: '#002E47',
    fontWeight: 400,
  },
  buttonContainer: {
    padding: '8px 0',
  },
})

export default styles
